import { USER_ID, USER_LIST } from "./userListAction";

const INITIAL_STATE = {
  users: [],
  userById: ''
};

const usersListReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USER_LIST:
         // Tomamos los usuarios existentes
      
      const existingUsers = state.users.flat(); // por si hay arrays dentro de arrays
       
      // Filtramos los nuevos que NO existen ya
      const newUsers = action.payload.filter(u => !existingUsers.includes(u));

      return {
        ...state,
        users: [...existingUsers, ...newUsers], // añadimos los nuevos al final
      };

    case USER_ID: 
     return {
      ...state,
      userById: action.payload
     }

    default:
      return state;
  }
};

export default usersListReducer